var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { sdsCustomElement } from '../utilities/custom-components';
import styles from './sds-illustration.lit.scss';
import { getIllustrationSrc } from './utils';
/**
 * `sds-illustration` is a web component designed to display illustrations in various formats.
 * It provides customizable attributes for specifying the name, format, and dimensions of the illustration.
 *
 * ### Attributes
 * - `name`: The name of the illustration.
 * - `format`: The format of the illustration, defaults to `'svg'`.
 * - `width`: The width of the illustration, defaults to `'480px'`.
 * - `height`: The height of the illustration, defaults to `'270px'`.
 *
 * @tag sds-illustration
 */
let SdsIllustration = (() => {
    var _SdsIllustration_name_accessor_storage, _SdsIllustration_format_accessor_storage, _SdsIllustration_width_accessor_storage, _SdsIllustration_height_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-illustration')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _format_decorators;
    let _format_initializers = [];
    let _format_extraInitializers = [];
    let _width_decorators;
    let _width_initializers = [];
    let _width_extraInitializers = [];
    let _height_decorators;
    let _height_initializers = [];
    let _height_extraInitializers = [];
    var SdsIllustration = _classThis = class extends _classSuper {
        /**
         * Name of this illustration.
         * This property specifies the name used to identify the illustration.
         *
         * @attr {string} name - The name of the illustration.
         */
        get name() { return __classPrivateFieldGet(this, _SdsIllustration_name_accessor_storage, "f"); }
        set name(value) { __classPrivateFieldSet(this, _SdsIllustration_name_accessor_storage, value, "f"); }
        /**
         * Format of this illustration.
         * This property determines the file format of the illustration, such as SVG or PNG.
         *
         * @attr {string} format - The format of the illustration.
         */
        get format() { return __classPrivateFieldGet(this, _SdsIllustration_format_accessor_storage, "f"); }
        set format(value) { __classPrivateFieldSet(this, _SdsIllustration_format_accessor_storage, value, "f"); }
        /**
         * Width of this illustration.
         * This property sets the width of the illustration in CSS units.
         *
         * @attr {string} width - The width of the illustration.
         */
        get width() { return __classPrivateFieldGet(this, _SdsIllustration_width_accessor_storage, "f"); }
        set width(value) { __classPrivateFieldSet(this, _SdsIllustration_width_accessor_storage, value, "f"); }
        /**
         * Height of this illustration.
         * This property sets the height of the illustration in CSS units.
         *
         * @attr {string} height - The height of the illustration.
         */
        get height() { return __classPrivateFieldGet(this, _SdsIllustration_height_accessor_storage, "f"); }
        set height(value) { __classPrivateFieldSet(this, _SdsIllustration_height_accessor_storage, value, "f"); }
        render() {
            return html `
            <img
                src="${getIllustrationSrc(this.name, this.format)}"
                style="width: ${this.width}; height: ${this.height}"
                alt="${this.name} illustration"
                part="sds-illustration"
                class="sds-illustration"
            />
        `;
        }
        constructor() {
            super(...arguments);
            _SdsIllustration_name_accessor_storage.set(this, __runInitializers(this, _name_initializers, ''));
            _SdsIllustration_format_accessor_storage.set(this, (__runInitializers(this, _name_extraInitializers), __runInitializers(this, _format_initializers, 'svg')));
            _SdsIllustration_width_accessor_storage.set(this, (__runInitializers(this, _format_extraInitializers), __runInitializers(this, _width_initializers, '480px')));
            _SdsIllustration_height_accessor_storage.set(this, (__runInitializers(this, _width_extraInitializers), __runInitializers(this, _height_initializers, '270px')));
            __runInitializers(this, _height_extraInitializers);
        }
    };
    _SdsIllustration_name_accessor_storage = new WeakMap();
    _SdsIllustration_format_accessor_storage = new WeakMap();
    _SdsIllustration_width_accessor_storage = new WeakMap();
    _SdsIllustration_height_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsIllustration");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _name_decorators = [property({ type: String })];
        _format_decorators = [property({ type: String })];
        _width_decorators = [property({ type: String })];
        _height_decorators = [property({ type: String })];
        __esDecorate(_classThis, null, _name_decorators, { kind: "accessor", name: "name", static: false, private: false, access: { has: obj => "name" in obj, get: obj => obj.name, set: (obj, value) => { obj.name = value; } }, metadata: _metadata }, _name_initializers, _name_extraInitializers);
        __esDecorate(_classThis, null, _format_decorators, { kind: "accessor", name: "format", static: false, private: false, access: { has: obj => "format" in obj, get: obj => obj.format, set: (obj, value) => { obj.format = value; } }, metadata: _metadata }, _format_initializers, _format_extraInitializers);
        __esDecorate(_classThis, null, _width_decorators, { kind: "accessor", name: "width", static: false, private: false, access: { has: obj => "width" in obj, get: obj => obj.width, set: (obj, value) => { obj.width = value; } }, metadata: _metadata }, _width_initializers, _width_extraInitializers);
        __esDecorate(_classThis, null, _height_decorators, { kind: "accessor", name: "height", static: false, private: false, access: { has: obj => "height" in obj, get: obj => obj.height, set: (obj, value) => { obj.height = value; } }, metadata: _metadata }, _height_initializers, _height_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsIllustration = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsIllustration = _classThis;
})();
export { SdsIllustration };
